import { UseFormReturn } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage, FormDescription } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";

interface AdditionalInfoStepProps {
  form: UseFormReturn<any>;
  onNext: () => void;
  onBack: () => void;
}

export const AdditionalInfoStep = ({ form, onNext, onBack }: AdditionalInfoStepProps) => {
  return (
    <Form {...form}>
      <div className="space-y-4">
        <h3 className="text-lg font-semibold">Additional Information</h3>
      
      <FormField
        control={form.control}
        name="referralSource"
        render={({ field }) => (
          <FormItem>
            <FormLabel>How did you hear about HTICU? *</FormLabel>
            <Select onValueChange={field.onChange} defaultValue={field.value}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select an option" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="website">Website</SelectItem>
                <SelectItem value="social-media">Social Media</SelectItem>
                <SelectItem value="referral">Referral from Friend/Family</SelectItem>
                <SelectItem value="church">Church Announcement</SelectItem>
                <SelectItem value="pastor">Pastor Recommendation</SelectItem>
                <SelectItem value="search-engine">Search Engine</SelectItem>
                <SelectItem value="other">Other</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="previouslyApplied"
        render={({ field }) => (
          <FormItem className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-4">
            <FormControl>
              <Checkbox
                checked={field.value}
                onCheckedChange={field.onChange}
              />
            </FormControl>
            <div className="space-y-1 leading-none">
              <FormLabel>
                Have you previously applied to HTICU?
              </FormLabel>
              <FormDescription>
                Check this box if you have submitted an application to HTICU in the past
              </FormDescription>
            </div>
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="specialAccommodations"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Special Accommodations (Optional)</FormLabel>
            <FormControl>
              <Textarea 
                {...field} 
                placeholder="Please describe any special accommodations you may need for your studies"
                rows={4}
              />
            </FormControl>
            <FormDescription>
              This information helps us ensure we can provide the support you need
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

        <div className="flex justify-between pt-4">
          <Button variant="outline" onClick={onBack}>Back</Button>
          <Button onClick={onNext}>Continue to Payment</Button>
        </div>
      </div>
    </Form>
  );
};
